import React from 'react';

import { type IntlShape } from 'react-intl';

import type { ADFEntity } from '@atlaskit/adf-utils/types';
import type { ExtensionParams } from '@atlaskit/editor-common/extensions';
import Image from '@atlaskit/image';
import {
	CommonLayout,
	type HubElement,
	type HubElementLayout,
	SPOTLIGHT_EXTENSION_TYPE,
} from '@atlassian/company-hub-common';

import { layoutOptions, SPOTLIGHT_EXTENSION_KEY } from '../../constants';
import type { SpotlightParameters } from '../../types';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { spotlightParameters } from '../spotlight-manifest';

import spotlightHubElementThumbnailDark from './assets/spotlightHubElementThumbnail-dark.svg';
import spotlightHubElementThumbnail from './assets/spotlightHubElementThumbnail.svg';
import { i18n } from './messages';
import { Spotlight } from './spotlight-extension/spotlight';

const getDefaultSpotlightNodeAdf = (intl: IntlShape, layout: CommonLayout): ADFEntity => {
	return {
		type: 'extension',
		attrs: {
			extensionKey: SPOTLIGHT_EXTENSION_KEY,
			extensionType: SPOTLIGHT_EXTENSION_TYPE,
			parameters: { ...spotlightParameters({ intl }), layout },
		},
	};
};
const thumbnailImage: React.ReactNode = (
	<Image src={spotlightHubElementThumbnail} srcDark={spotlightHubElementThumbnailDark} alt="" />
);

const getLayoutPreviewComponent = (intl: IntlShape, layout: CommonLayout) => {
	return (
		<Spotlight
			extensionNode={
				getDefaultSpotlightNodeAdf(intl, layout).attrs as ExtensionParams<SpotlightParameters>
			}
			contentId=""
		/>
	);
};

const getHubElementLayouts = (): HubElementLayout[] => {
	return layoutOptions.map((layout) => ({
		...layout,
		getNodeAdf: (intl: IntlShape) => getDefaultSpotlightNodeAdf(intl, layout.value),
		getPreviewComponent: (intl: IntlShape) => getLayoutPreviewComponent(intl, layout.value),
	}));
};

export const spotlightHubElement: HubElement = {
	extensionKey: SPOTLIGHT_EXTENSION_KEY,
	title: i18n.spotlightTitle,
	description: i18n.spotlightDescription,
	Image: thumbnailImage,
	layouts: getHubElementLayouts(),
	hasNewLozenge: true,
	getNodeAdf: (intl: IntlShape) => getDefaultSpotlightNodeAdf(intl, CommonLayout.SPLIT_IMAGE_RIGHT),
};
